import { CountryCodes } from '@/enums/general'

export const ResponseTypes = Object.freeze({
  address: 'Address'
})

export const LoqateCountries = Object.freeze([
  CountryCodes.france,
  CountryCodes.netherlands,
  CountryCodes.unitedKingdom,
  CountryCodes.belgium,
  CountryCodes.spain,
  CountryCodes.denmark,
  CountryCodes.germany,
  CountryCodes.austria,
  CountryCodes.sweden,
  CountryCodes.italy,
  CountryCodes.poland,
  CountryCodes.switzerland,
  CountryCodes.ireland,
  CountryCodes.luxembourg,
  CountryCodes.portugal,
  CountryCodes.finland,
  CountryCodes.norway,
  CountryCodes.czechRepublic
])
